export default __webpack_public_path__ + "static/media/nube.917d7b01.png";